import * as yup from 'yup';

/**
 * Custom validation function for required string fields that ensures they're not empty
 */
export const yupRequiredNonEmptyString = (fieldName: string) =>
  yup
    .string()
    .required(`${fieldName} is required`)
    .test('not-empty', `${fieldName} cannot be empty`, (value) =>
      Boolean(value && value.trim().length > 0)
    );
